import { TableCell } from '@mui/material';

interface CardsTableCellProps {
  id: string;
  children: React.ReactNode;
  cellWidth?: number;
  isColorMix?: boolean;
}

export const CardsTableCell = ({
  id,
  children,
  cellWidth,
  isColorMix,
}: CardsTableCellProps) => {
  const labelId = `enhanced-table-${id}`;

  return (
    <TableCell
      id={labelId}
      scope="row"
      align="left"
      sx={(theme) => ({
        paddingTop: '3px',
        paddingBottom: '3px',
        color: theme.colors.white,
        fontSize: 11,
        borderBottomColor: !isColorMix ? theme.colors.white10 : undefined,
        borderWidth: !isColorMix ? '1px' : 0,
        width: cellWidth,
        maxWidth: cellWidth,
        overflow: 'hidden',
        '@media (max-width: 768px)': {
          paddingLeft: '4px',
          paddingRight: '4px',
          fontSize: 9,
        },
        '@media (max-width: 480px)': {
          paddingLeft: '4px',
          paddingRight: '4px',
          fontSize: 8,
        },
      })}
    >
      {children}
    </TableCell>
  );
};
